import React from "react";
import { IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle } from "@ionic/react";
import classNames from "classnames/bind";
import styles from "./OrderSummary.module.scss";
import { Address, ShippingMethod, ShippingMethodDeliveryType } from "@core/types";
import { generateDeliveryRangeText } from "../../utils";
import { useTranslation } from "react-i18next";

interface IOrderSummaryDetails {
  title: string;
  address: Address;
  deliveryDate?: Date | null;
  deliveryInterval: string;
  shippingMethod: ShippingMethod | null;
  shippingIsDefine: any;
  paymentMethodTitle: string;
}

const cx = classNames.bind(styles);

const OrderSummaryDetails: React.FC<IOrderSummaryDetails> = ({
  title,
  address,
  deliveryDate,
  deliveryInterval,
  shippingMethod,
  shippingIsDefine,
  paymentMethodTitle,
}) => {
  const { t } = useTranslation();
  return (
    <IonCard className={cx("orderSummary")}>
      <IonCardHeader className={cx("orderSummaryHeader")} color="primary">
        <IonCardTitle className={cx("orderSummaryTitle")}>{title}</IonCardTitle>
      </IonCardHeader>
      <IonCardContent className={cx("orderSummaryContent")}>
        {shippingIsDefine && (
          <>
            <IonCardSubtitle className={cx("orderSummarySubtitle")}>{t("Shipping Address")}</IonCardSubtitle>
            <p className={cx("orderSummaryDescription")}>
              <span>{`${t("Address")}: `}</span>
              {address.fullAddress}
              <br />
              {address.isFlat && (
                <>
                  <span>{`${t("Entrance")}: `}</span>
                  {address.entrance}
                  <br />
                  {!!address.intercom && (
                    <>
                      <span>{`${t("Intercom code")}: `}</span>
                      {address.intercom}
                      <br />
                    </>
                  )}
                  <span>{`${t("Floor")}: `}</span>
                  {address.floor}
                  <br />
                  <span>{`${t("Apartment number")}: `}</span>
                  {address.apartmentNumber}
                </>
              )}
            </p>
          </>
        )}

        {deliveryDate && shippingMethod?.methodDeliveryType === ShippingMethodDeliveryType.default && (
          <>
            <IonCardSubtitle className={cx("orderSummarySubtitle")}>{t("Delivery date and interval")}</IonCardSubtitle>
            <p className={cx("orderSummaryDescription")}>
              <span>Дата: </span>
              {deliveryDate.toLocaleDateString()}
              {deliveryInterval && (
                <>
                  <br />
                  <span>Время: </span>
                  {deliveryInterval}
                </>
              )}
            </p>
          </>
        )}

        {shippingMethod?.methodDeliveryType === ShippingMethodDeliveryType.nextDay && (
          <>
            <IonCardSubtitle className={cx("orderSummarySubtitle")}>{t("Delivery date")}</IonCardSubtitle>
            <p className={cx("orderSummaryDescription")}>{generateDeliveryRangeText(shippingMethod)}</p>
          </>
        )}

        <IonCardSubtitle className={cx("orderSummarySubtitle")}>{t("Payment Method")}</IonCardSubtitle>
        <p className={cx("orderSummaryDescription")}>{paymentMethodTitle}</p>
        {shippingMethod && (
          <>
            <IonCardSubtitle className={cx("orderSummarySubtitle")}>{t("Shipping Method")}</IonCardSubtitle>
            <p className={cx("orderSummaryDescription")}>{shippingMethod.title}</p>
          </>
        )}
      </IonCardContent>
    </IonCard>
  );
};

export default OrderSummaryDetails;
